import { Component } from '@angular/core'

@Component({
  templateUrl: './lector-manual-ru.component.html',
  styleUrls: ['../lector-manual.component.less'],
  selector: 'app-lector-manual-ru',
})
export class LectorManualComponentRu {}
